import { List, merge, type RecordOf } from 'immutable';

import { isRecordOf } from './recordHelpers';

interface Page {
  rows?: unknown[];
}

interface Payload {
  resources: Array<Page | RecordOf<Page>>;
}

// The pages' own fields vary by report, so they go through Immutable's untyped merge.
export const upsertReports = <S extends object>(state: S, payload: Payload): S => {
  const root = payload.resources[0];
  const rows = payload.resources
    ?.reduce((list, page) => list.concat(page.rows), List<unknown>().asMutable())
    .asMutable();
  const newState = merge(state, {
    ...(isRecordOf(root) ? root.toJS() : root),
    rows,

    isLoading: false,
    error: undefined,
    loadPending: false,
  });
  return newState;
};
